import { Pressable, StyleSheet, Text, View } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";

import { fontFamily, space } from "@passfirst/ui";

interface Props {
  coachName: string;
  coachSub: string;
  onClose: () => void;
}

// Voice screen top bar: coach identity left, round white-on-translucent
// X close button right. Replaces what would otherwise be a back-arrow
// pattern — voice is a "session" you close, not a page you back out of.
export function VoiceTopBar({
  coachName,
  coachSub,
  onClose,
}: Props): JSX.Element {
  const insets = useSafeAreaInsets();
  return (
    <View style={[styles.bar, { paddingTop: insets.top + space[6] }]}>
      <View style={styles.identity}>
        <Text style={styles.name}>{coachName}</Text>
        <Text style={styles.sub}>{coachSub}</Text>
      </View>
      <Pressable
        onPress={onClose}
        accessibilityRole="button"
        accessibilityLabel="Close voice coach"
        style={styles.closeBtn}
      >
        <Text style={styles.closeGlyph}>×</Text>
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  bar: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 22,
    paddingTop: space[6],
    paddingBottom: 14,
  },
  identity: { gap: 2 },
  name: {
    fontFamily: fontFamily.bold,
    fontSize: 15,
    color: "#FFFFFF",
  },
  sub: {
    fontFamily: fontFamily.regular,
    fontSize: 12,
    color: "#9FB2CC",
  },
  closeBtn: {
    width: 34,
    height: 34,
    borderRadius: 17,
    backgroundColor: "rgba(255,255,255,0.12)",
    alignItems: "center",
    justifyContent: "center",
  },
  closeGlyph: {
    fontSize: 22,
    color: "#FFFFFF",
    fontFamily: fontFamily.regular,
    lineHeight: 24,
  },
});
